module.exports = __webpack_public_path__ + "static/media/Dashboardwhitebg.1d993188.png";